module.exports = __webpack_public_path__ + "img/Store.263ba8dd.png";